import { render } from "./GiftcardPurchaseSuccess.vue?vue&type=template&id=5c9366aa"
import script from "./GiftcardPurchaseSuccess.vue?vue&type=script&lang=js"
export * from "./GiftcardPurchaseSuccess.vue?vue&type=script&lang=js"

import exportComponent from "/__w/system/system/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__